import { render, staticRenderFns } from "./ebook.vue?vue&type=template&id=25c7a1e0&scoped=true&"
import script from "./ebook.vue?vue&type=script&lang=js&"
export * from "./ebook.vue?vue&type=script&lang=js&"
import style0 from "./ebook.vue?vue&type=style&index=0&id=25c7a1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c7a1e0",
  null
  
)

export default component.exports